// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"562":"c7cf6dd5","944":"07e4d54c"}[chunkId] + ".chunk.js";
};